export const limitString = (str, limit) => {
  if (!str) return ""
  if (str.length <= limit) return str;
  return str.substring(0, str.length - (str.length - limit)) + "...";
};
